import axios from "axios";

// Resolve API base URL with safe production fallback + protocol normalization:
// - If REACT_APP_BACKEND_URL is set at build time, use it.
// - Otherwise (e.g. production deploys where the env var wasn't baked into the
//   bundle) fall back to same-origin so /api/* hits the same host serving the
//   frontend. This makes the app self-healing on custom-domain deploys.
// - If a URL was provided WITHOUT a protocol (a common deployment-secrets
//   mistake — e.g. `app.example.com` instead of `https://app.example.com`),
//   the protocol is auto-prepended so the request doesn't get mangled into
//   `https://current-origin.com/app.example.com/api/...`.
function _resolveBackendUrl() {
  const raw = (process.env.REACT_APP_BACKEND_URL || "").trim();
  if (!raw) {
    return typeof window !== "undefined" ? window.location.origin : "";
  }
  // Strip trailing slashes
  const clean = raw.replace(/\/+$/, "");
  // If protocol missing, prepend https:// (or http:// for localhost)
  if (!/^https?:\/\//i.test(clean)) {
    const proto = /^localhost(:\d+)?$/i.test(clean) ? "http://" : "https://";
    return proto + clean;
  }
  return clean;
}

const RAW_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const BACKEND_URL = _resolveBackendUrl();

export const API = `${BACKEND_URL}/api`;

// Diagnostic: log once so production support can confirm the request target
// matches the expected domain (visible in browser DevTools → Console).
if (typeof window !== "undefined" && !window.__BTT_API_LOGGED) {
  // eslint-disable-next-line no-console
  console.info(
    `[BTT] API base = ${API}` +
      (RAW_BACKEND_URL ? "" : "  (using same-origin fallback)") +
      `  | origin = ${window.location.origin}`
  );
  window.__BTT_API_LOGGED = true;
}

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Also send Authorization header as a fallback (in case cookies blocked)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("btt_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
